import { Component, OnInit } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import { SearchOption } from '../../searchOption';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { map, debounceTime, distinctUntilChanged, switchMap, } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent implements OnInit {

  searchResults$: Observable<SearchOption[]>;
  term$ = new Subject<string>();
  windowOpen$: Observable<boolean>;

  constructor(
    private router: Router,
    private searchService: SearchService,
  ) {
    this.searchResults$ = this.term$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) =>
        term.length == 0 ? of([]) : this.searchService.getRelatedTier3ForSeek(term)
      )
    );
  }

  ngOnInit(): void {
    this.windowOpen$ = this.searchResults$.pipe(
      map((searchOptionsArr) => (searchOptionsArr.length > 0 ? true : false))
    );
  }

  /* termPreLoad={} */
  onSubmit(f: NgForm, searchEval: any) {
    const tempTerm = f.value.search

    if (!searchEval.errors) {
      this.searchService.options$ = this.searchService.getRelatedTier3ForSeek(tempTerm);

      this.searchService.isOptionsEmpty$ = this.searchService.options$.pipe(
        map((options) => (options.length == 0 ? true : false))
      );

      this.router.navigate(['/search-results-list']);
      f.resetForm();

      /* Emitimos la accion */
      this.searchService.shooterFirstPagePaginator.emit({
        data: 1,
        termSearch: tempTerm
      })
    }
  }

}
